export default {"src":"/_next/static/media/discord.9a49469b.svg","height":54,"width":69,"blurWidth":0,"blurHeight":0};